

document.addEventListener('DOMContentLoaded', () => {
  function openOmnisendForms() {
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', '68d40f78845e5c93e3f14ab2']);
  }

  function initPreLaunchButtons() {
    let pre_launch_btn = document.querySelectorAll('.pre_launch_btn');
    if (pre_launch_btn.length > 0) {
      pre_launch_btn.forEach((btn) => {
        btn.addEventListener('click', openOmnisendForms);
      });
    }
  }

  // Call the function after DOM is loaded
  initPreLaunchButtons();
  document.addEventListener('related:happen', initPreLaunchButtons);

  //Launching soon Button
  function openLaunchingSoonForm() {
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', '68d40f78845e5c93e3f14ab2']);
  }

  function initLaunchingSoon() {
    let pre_launch_btn = document.querySelectorAll('.launching_soon');
    if (pre_launch_btn.length > 0) {
      pre_launch_btn.forEach((btn) => {
        btn.addEventListener('click', openLaunchingSoonForm);
      });
    }
  }

  // Call the function after DOM is loaded
  initLaunchingSoon();
  document.addEventListener('related:happen', initLaunchingSoon);
});

$(document).ready(function() {
  $(".dynamic_title h3").each(function(i) {
   var heading = $(this);
    var headingtext = heading.text().toLowerCase().trim().replace(/[\s.,-\/#!?$%\^&\*;:{}=\-_`~()]/g,"-");
     heading.attr("id",headingtext);
    heading.each(function(){
      $(".dynamic_title #article-titles").append(`<li><a href="#${headingtext}">${$(this).text()}</a></li>`);
    })
   });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".header");

//   if (!header) return;

//   function updateHeaderHeight() {
//     const headerRect = header.getBoundingClientRect();
//     const isHeaderVisible = headerRect.top >= 0 && headerRect.bottom > 0; // Detect visibility

//     if (isHeaderVisible) {
//       document.documentElement.style.setProperty("--header-height", `${header.offsetHeight}px`);
//       console.log("Header is Visible:", header.offsetHeight);
//     } else {
//       document.documentElement.style.setProperty("--header-height", "10px");
//       console.log("Header is Not Visible");
//     }
//   }

//   window.addEventListener("scroll", updateHeaderHeight);
//   window.addEventListener("resize", updateHeaderHeight);

//   // Run once on page load
//   updateHeaderHeight();

// Browse By Department Start
let browseByDepDrop = document.querySelectorAll('.product_list_wrapper .swiper.product_list_init');
  browseByDepDrop.forEach(function(browseByDepSlider){
    let browseByDepartment = new Swiper(browseByDepSlider, {
      // Optional parameters
      loop: false,
      slidesPerView:3,
      spaceBetween: 15,
      followFinger: true,
      speed: 750,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 2,
      },
      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        576: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 18,
        }
      }
    }); 
  })
// });

